// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3o9Yo","title":"styles_title__1M9QD","table":"styles_table__3jcyM"};